import { filledPhone } from 'assets'
import { Button } from 'components/button/Button'
import { constants } from 'helpers'
import { useAnalytics } from 'hooks'
import React from 'react'

export const ClientPhone = ({
    clientPhoneInfo,
    permissions,
    modifyHandler
}: {
    clientPhoneInfo: { formatPhone: string; clientPhone: string }
    clientInteractionStatus: {
        btnStyle: 'info' | 'light' | 'warning'
        color: string
        className: string
    }
    permissions: {
        isClientDuplicate: boolean
    }
    modifyHandler?: () => void
}) => {
    const { trackEvent } = useAnalytics()
    const normalizedPhone = clientPhoneInfo?.clientPhone?.trim()
    const hasValidPhone = Boolean(normalizedPhone && normalizedPhone !== '0')
    const handlePhoneClick = () => {
        if (!hasValidPhone && modifyHandler) {
            modifyHandler()
        }
    }

    const handleValidPhoneClick = () => {
        trackEvent({
            category: constants.ANALYTICS.CLIENT_DETAILS,
            action: constants.ANALYTICS.ACTIONS.PHONE_CALL
        })
    }

    return (
        <>
            <Button
                className={`card-client-detail--${
                    permissions.isClientDuplicate
                        ? 'client-phone-duplicate'
                        : 'client-phone'
                }`}
                style="solid"
                icon={filledPhone({
                    color: permissions.isClientDuplicate ? '#979797' : '#16A34A'
                })}
                iconPos="left"
                id="client-details-phone-btn"
                data-testid="phone-button"
                onClick={!hasValidPhone ? handlePhoneClick : undefined}
            >
                {hasValidPhone ? (
                    <a
                        href={`tel:${clientPhoneInfo.clientPhone}`}
                        className={[
                            'phone-number-text',
                            `phone-number-text--${
                                permissions?.isClientDuplicate
                                    ? 'duplicate'
                                    : 'normal'
                            }`
                        ].join(' ')}
                        aria-label="phone-number-link"
                        onClick={handleValidPhoneClick}
                    >
                        {clientPhoneInfo.formatPhone}
                    </a>
                ) : (
                    <span
                        className={[
                            'phone-number-text',
                            'phone-number-text--disabled'
                        ].join(' ')}
                        aria-label="phone-number-disabled"
                    >
                        {clientPhoneInfo?.formatPhone}
                    </span>
                )}
            </Button>
        </>
    )
}
